import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, finalize, Observable } from 'rxjs';
import { EnvironmentToken } from '../../app.config';
import { Checkpoint } from '../models/checkpoint.model';

export class CheckpointService {
  #http = inject(HttpClient);
  #apiUrl = inject(EnvironmentToken).apiUrl;
  #isLoading = signal<Set<unknown>>(new Set());

  #checkpoints = new BehaviorSubject<Checkpoint[]>([]);

  public checkpoints$ = this.#checkpoints.asObservable();
  public checkpoints = toSignal(this.checkpoints$, {
    initialValue: [],
  });

  getCheckpoints(params: { time_from: Date; time_to: Date }) {
    const httpParams = new HttpParams()
      .set('time_from', params.time_from.toISOString())
      .set('time_to', params.time_to.toISOString());
    this.#execute(
      this.#http.get<Checkpoint[]>(
        `${this.#apiUrl}/api/operator/overview`,
        { params: httpParams },
      ),
    ).subscribe({
      next: (checkpoint) => this.#checkpoints.next(checkpoint),
      error: (e) => console.log(e),
    });
  }

  #execute<T = unknown>(apiCall: Observable<T>) {
    this.#isLoading.update((x) => {
      x.add(apiCall);
      return new Set(x.values());
    });
    return apiCall.pipe(
      finalize(() =>
        this.#isLoading.update((x) => {
          x.delete(apiCall);
          return new Set(x.values());
        }),
      ),
    );
  }
}
